import { Suspense, type ReactNode } from "react";
import { RoutePageFallback } from "@/components/routing/RoutePageFallback";

/** Suspense boundary for standalone route trees (public pages outside {@link AuthenticatedLayout}). */
export function LazyBoundary({ fullscreen, children }: { fullscreen?: boolean; children: ReactNode }) {
  return (
    <Suspense fallback={<RoutePageFallback variant={fullscreen ? "fullscreen" : "content"} />}>
      {children}
    </Suspense>
  );
}
